const NEWS_URL = '/news/latest'

export default function ({ route }) {
  if (route.path === '/news/post/21') {
    window.location.replace(NEWS_URL)
  }
}
